//connect different data structures together, match by main or id
//dataset 1

const backgroundColor = [
    {
        icon: "01d",
        description: "clear sky",
        background: "radial-gradient(50% 50% at 50% 50%, #FFFFFF 12%, #6FACE5 100%)",
    },
    {
        icon: "01n",
        description: "clear sky",
        background: "radial-gradient(50% 50% at 50% 50%, #405C76 0%, #04182B 100%)",
    },
    {
        icon: "02d",
        description: "few clouds",
        background: "#74a1d1",
    },
    {
        icon: "02n",
        description: "few clouds",
        background: "linear-gradient(180deg, #152534 0%, #3a5266 100%)",
    },
    {
        icon: "03d",
        description: "scattered clouds",
        background: "linear-gradient(0deg, #CEE7FF 0%, #1A68B0 100%)",
    },
    {
        icon: "03n",
        description: "scattered clouds",
        background: "linear-gradient(180deg, #021323 0%, #47647E 100%)",
    },
    {
        icon: "04d",
        description: ["broken clouds", "overcast clouds"],
        background: "#74a1d1", 
    },
    {
        icon: "04n",
        description: ["broken clouds", "overcast clouds"],
        background: "linear-gradient(180deg, #000000 0%, #0B3A66 100%)",
    },
    {
        icon: "09d",
        description: "shower rain",
        background: "linear-gradient(0deg, #A7D4FF 2.08%, #ADCEEC 14.25%, #83939F 100%)",
    },
    {
        icon: "09n",
        description: "shower rain",
        background: "linear-gradient(180deg, #2E3032 0%, #1B3F60 100%)",
    },
    {
        icon: "10d",
        description: "rain",
        background: "linear-gradient(180deg, #092234 0%, #657E8F 58.85%, #ACC4D6 100%)",
    },
    {
        icon: "10n",
        description: "rain",
        background: "linear-gradient(180deg, #000000 0.01%, #5D778E 100%)",
    },
    {
        icon: "11d",
        description: "thunderstorm",
        background: "#434D5D",
    },
    {
        icon: "11n",
        description: "thunderstorm",
        background: "#54516F",
    },
    {
        icon: "13d",
        description: "snow",
        background: "linear-gradient(10deg, #C9D3DC 0%, #FFFFFF 100%)",
    },
    {
        icon: "13n",
        description: "snow",
        background: "linear-gradient(180deg, #182534 0.01%, #606E7A 100%)",
    },
    {
        icon: "50d",
        description: "mist",
        background: "linear-gradient(180deg, #67849F 0%, #C4CFD9 66.67%, #E4E4E4 100%)", 
    },
    {
        icon: "50n",
        description: "mist",
        background: "linear-gradient(180deg, #000000 0%, #1B3F60 100%)",
    },

];

export default backgroundColor;
//bring in the different assets
//dataset 2
//this needs double verification of icon and description 
